<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar title="Facturas" :back-link="isPopup ? null : $t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- rList Table CARD-->
      <r-dynamic-list
        ref="facturasList"
        :dbAdapter="Factura"
        :tableCode="'FACTURA'"
        :tableMode="true"
        :mandatoryFilter="mandatoryFilter"
        :searchOnInit="searchOnInit"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table responsive-table"
        classContent="card-content full-height"
        :shownFields="computedShownFields"
        :massiveActions="true"
        :showProgress="false"
        :controlsWidth="105"
        :ignoreTableFilters="ignoreTableFilters"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver')" icon-f7="eye" color="green" :href="`/facturas/view/${item.id}/`"></f7-link>
          <!-- <f7-link v-if="item.docStatus && item.docStatus == 'O'" v-tooltip="$t('common.editar')" icon-f7="square_pencil" color="blue" :href="`/facturas/edit/${item.id}/`"></f7-link> -->
          <f7-link v-tooltip="item.documentoFactura?$t('common.descargar'):$t('facturas.no_documento')" icon-f7="doc" :color="item.documentoFactura?'green':'gray'" @click="download(item)"></f7-link>
          <f7-link v-if="item.bcId" v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.verEnBC')" icon-f7="link" color="orange" @click="verEnBC(item.bcId)"></f7-link>
          <f7-link v-tooltip="$t('common.opciones')" icon-f7="ellipsis_vertical" color="blue" @click="showMenuOptions(item)"></f7-link>
        </template>
        <template v-slot:massiveActions="{selecteds}">
          <!-- <f7-button
            fill
            icon-f7="checkmark_alt"
            :text="$t('facturas.crear_pdf')"
            class="display-flex"
            color="green"
            @click="crearPdf(Object.values(selecteds))"
          ></f7-button> -->
          <!-- <f7-button
            fill
            icon-f7="checkmark_alt"
            :text="$t('facturas.asignar_pdf')"
            class="display-flex"
            color="lime"
            @click="asignarPdf(Object.values(selecteds))"
          ></f7-button> -->
          <f7-button
            fill
            icon-f7="checkmark_alt"
            :text="$t('facturas.crear_tarea')"
            class="display-flex"
            color="blue"
            @click="crearTarea(Object.values(selecteds))"
          ></f7-button>
          <f7-button
            fill
            icon-f7="envelope"
            text="Enviar email"
            class="display-flex"
            color="purple"
            @click="abrirEnvioEmail(Object.values(selecteds))"
          ></f7-button>
          <f7-link @click="$refs.facturasList.reload()" icon-f7="arrow_counterclockwise" v-tooltip="$t('common.actualizarTabla')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>

    <listado-mails
      v-if="verListadoMails"
      :filterValue="id"
      :entityType="'factura'"
      @listado-cerrado="verListadoMails = false"
    ></listado-mails>
    
    <listado-tareas
      v-if="verListadoTareas"
      filterName="facturas.codigo"
      :filterValue="codigo"
      entityField="facturas.codigo"
      tableCode="TAREASFACTURA"
      :shownFields="['facturas.codigo', 'facturas.numero', 'facturas.tipo']"
      @listado-cerrado="verListadoTareas = false"
    ></listado-tareas>
    
    <envio-mail
      v-if="enviarEmail"
      ref="enviarEmail"
      :selected="selectedItems"
      :entityConfig="emailConfigs.factura"
      @email-enviado="onEmailEnviado"
    ></envio-mail>
    
    <!-- Popup de selección de certificados -->
    <f7-popup ref="popupSeleccionCertificados" :opened="mostrarSeleccionCertificados" @popup:closed="mostrarSeleccionCertificados = false" tablet-fullscreen>
      <f7-page>
        <f7-navbar>
          <f7-nav-left></f7-nav-left>
          <f7-nav-title>Seleccionar Certificados</f7-nav-title>
          <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-page-content class="popup-content-certificates">
          <!-- Filtros y controles fijos -->
          <div class="filter-controls-fixed">
            <f7-block class="filter-controls-block">
              <f7-row>
                <f7-col width="75">
                  <f7-list form no-hairlines class="filter-list">
                    <f7-list-input
                      label="Filtrar por código, estado, nº factura o cliente"
                      type="text"
                      placeholder="Escriba para filtrar..."
                      :value="filtroTexto"
                      @input="filtrarCertificados"
                      clear-button
                      @input:clear="limpiarFiltro"
                    >
                      <template #media>
                        <f7-icon f7="search" size="18px"></f7-icon>
                      </template>
                    </f7-list-input>
                  </f7-list>
                </f7-col>
                <f7-col width="25" class="buttons-col-inline">
                  <f7-button small fill @click="seleccionarTodosVisibles" class="action-button-icon" v-tooltip="'Seleccionar Todo'">
                    <f7-icon f7="checkmark_alt" size="16px"></f7-icon>
                  </f7-button>
                  <f7-button small fill color="red" @click="deseleccionarTodosVisibles" class="action-button-icon" v-tooltip="'Deseleccionar Todo'">
                    <f7-icon f7="clear" size="16px"></f7-icon>
                  </f7-button>
                </f7-col>
              </f7-row>
            </f7-block>
          </div>
          
          <!-- Lista de certificados con scroll -->
          <div class="certificates-scroll-container">
            <f7-list class="certificates-list">
              <f7-list-item
                v-for="(certificado, index) in certificadosFiltradosComputed"
                :key="`cert-${certificado.id}-${index}`"
                :class="esCertificadoSeleccionado(certificado) ? 'item-selected' : 'item-unselected'"
                @click="toggleCertificadoSeleccion(certificado)"
              >
                <template #media>
                  <f7-icon 
                    :f7="esCertificadoSeleccionado(certificado) ? 'checkmark_circle_fill' : 'circle'" 
                    :color="esCertificadoSeleccionado(certificado) ? 'green' : 'gray'"
                  ></f7-icon>
                </template>
                
                <!-- Contenido personalizado con cuatro columnas -->
                <template #title>
                  <f7-row class="certificate-row">
                    <f7-col width="20" class="certificate-col">
                      <div class="certificate-field">
                        <small class="certificate-label">Nº Factura</small>
                        <div class="certificate-value" v-tooltip="certificado.numeroFactura ? String(certificado.numeroFactura) : 'N/A'">{{ certificado.numeroFactura }}</div>
                      </div>
                    </f7-col>
                    <f7-col width="30" class="certificate-col">
                      <div class="certificate-field">
                        <small class="certificate-label">Código Expediente</small>
                        <div class="certificate-value" v-tooltip="certificado.codigoExpediente || 'N/A'">{{ certificado.codigoExpediente }}</div>
                      </div>
                    </f7-col>
                    <f7-col width="30" class="certificate-col">
                      <div class="certificate-field">
                        <small class="certificate-label">Cliente</small>
                        <div class="certificate-value" v-tooltip="certificado.cliente ? certificado.cliente.razonSocial : 'N/A'">{{ certificado.cliente ? certificado.cliente.razonSocial : 'N/A' }}</div>
                      </div>
                    </f7-col>
                    <f7-col width="10" class="certificate-col">
                      <div class="certificate-field">
                        <small class="certificate-label">Estado</small>
                        <div class="certificate-value" v-tooltip="certificado.estadoExpediente || 'N/A'">{{ certificado.estadoExpediente }}</div>
                      </div>
                    </f7-col>
                    <f7-col width="10" class="certificate-actions">
                      <f7-link icon-f7="eye" color="green" @click.stop="abrirInspeccion(certificado.idExpediente)" v-tooltip="'Ver expediente'" class="certificate-link"></f7-link>
                      <f7-link icon-f7="doc" color="green" @click.stop="descargarCertificado(certificado)" v-tooltip="'Descargar certificado'" class="certificate-link"></f7-link>
                      <!-- <f7-link icon-f7="doc" color="blue" @click.stop="visualizarCertificado(certificado)" v-tooltip="'Visualizar certificado'" class="certificate-link"></f7-link> -->
                    </f7-col>
                  </f7-row>
                </template>
              </f7-list-item>
            </f7-list>
          </div>
          
          <!-- Resumen y botones de acción fijos -->
          <div class="summary-controls-fixed">
            <f7-block class="summary-block">
              <f7-row>
                <f7-col width="33" class="text-align-center">
                  <small><strong>Total:</strong> {{ certificados.length }}</small>
                </f7-col>
                <f7-col width="33" class="text-align-center">
                  <small><strong>Mostrando:</strong> {{ certificadosFiltradosComputed.length }}</small>
                </f7-col>
                <f7-col width="34" class="text-align-center">
                  <small><strong>Seleccionados:</strong> {{ certificadosSeleccionados.length }}</small>
                </f7-col>
              </f7-row>
              
              <f7-button large fill color="blue" @click="confirmarSeleccionCertificados" class="confirm-button">
                <f7-icon f7="checkmark_alt" size="18px"></f7-icon>
                Confirmar Selección ({{ certificadosSeleccionados.length }})
              </f7-button>
            </f7-block>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>

    <!-- Popup de selección de documentos -->
    <f7-popup ref="popupSeleccionDocumentos" :opened="showDocumentosPopup" @popup:closed="showDocumentosPopup = false">
      <f7-page>
        <f7-navbar>
          <f7-nav-left>
            <f7-link @click="showDocumentosPopup = false">
              <!-- <f7-icon f7="xmark"></f7-icon> -->
            </f7-link>
          </f7-nav-left>
          <f7-nav-title>Seleccionar Documento</f7-nav-title>
          <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <f7-list>
            <f7-list-item 
              v-for="documento in documentosDisponibles" 
              :key="documento.nombre"
              class="documento-item"
            >
              <div class="documento-content">
                <div class="documento-nombre">
                  {{ documento.nombre }}.{{ documento.extension }}
                </div>
                <div class="documento-acciones">
                  <f7-button small color="blue" @click="descargarDocumento(documento)">
                    <f7-icon f7="cloud_download" size="16px"></f7-icon>
                  </f7-button>
                  <f7-button small color="green" @click="asignarDocumento(documento)">
                    <f7-icon f7="paperclip" size="16px"></f7-icon>
                  </f7-button>
                  <f7-button small color="red" @click="eliminarDocumento(documento)">
                    <f7-icon f7="trash" size="16px"></f7-icon>
                  </f7-button>
                </div>
              </div>
            </f7-list-item>
          </f7-list>
        </f7-page-content>
      </f7-page>
    </f7-popup>

    <f7-popup ref="popupTarea" swipe-to-close :opened="true" v-if="popupTareasOpened" @popup:closed="popupTareasOpened = false;" >
      <tarea-form :editable="true" @close="$refs.popupTarea.close();"
        :defaultData="dataTarea" :esPopup="true"
      ></tarea-form>
    </f7-popup>

  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<style>
  /* Estilo para centrar el Action Sheet verticalmente */
  .actions-centered .actions-modal {
    top: 50% !important;
    bottom: auto !important;
    transform: translateY(-50%) !important;
    margin: 0 auto !important;
    max-width: 350px !important;
    border-radius: 12px !important;
  }
  
  .actions-centered .actions-backdrop {
    background: rgba(0, 0, 0, 0.4) !important;
  }

  /* Estilo para el diálogo de crear PDF con mayor ancho */
  .dialog-crear-pdf .dialog-inner {
    max-width: 500px !important;
    width: 90% !important;
    min-width: 400px !important;
  }

  .dialog-crear-pdf .dialog-buttons {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .dialog-crear-pdf .dialog-button {
    margin: 0 !important;
    min-height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 8px 16px !important;
  }

  

  /* Estilos generales responsive */
  .data-table {
    width: 100% !important;
    overflow-x: auto !important;
  }
  
  .data-table .table-content {
    min-width: 100% !important;
  }
  

  
  /* Ajustar el ancho del contenedor principal */
  .full-height .card {
    margin: 0 !important;
    width: 100% !important;
  }

  /* Estilos para selección de certificados */
  .item-selected {
    background-color: #e8f5e8 !important;
    border-left: 4px solid #4caf50 !important;
  }
  
  .item-unselected {
    background-color: #f9f9f9 !important;
    border-left: 4px solid #e0e0e0 !important;
  }

  /* Estilos para el popup de certificados con scroll controlado */
  .popup-content-certificates {
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }

  /* Filtros fijos en la parte superior */
  .filter-controls-fixed {
    flex-shrink: 0 !important;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
  }

  .filter-controls-block {
    margin: 8px 0 0 0 !important;
    padding: 10px 15px !important;
    background: transparent !important;
    border: none !important;
  }

  /* Contenedor con scroll solo para certificados */
  .certificates-scroll-container {
    flex: 1 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    min-height: 0 !important;
  }

  /* Botones de resumen fijos en la parte inferior */
  .summary-controls-fixed {
    flex-shrink: 0 !important;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
  }
  
  .filter-list {
    margin: 0 !important;
  }
  
  .filter-list .list {
    margin: 0 !important;
    background: transparent !important;
  }
  
  .buttons-col-inline {
    display: flex !important;
    flex-direction: row !important;
    gap: 8px !important;
    justify-content: flex-end !important;
    align-items: center !important;
    padding-left: 10px !important;
  }
  
  .action-button-icon {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
  }
  
  .buttons-col {
    display: flex !important;
    flex-direction: column !important;
    gap: 5px !important;
    padding-left: 10px !important;
  }
  
  .action-button {
    height: 32px !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 5px !important;
  }
  
  .certificates-list {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  
  .summary-block {
    background: transparent !important;
    border: none !important;
    margin: 0 !important;
    padding: 15px !important;
  }
  
  .confirm-button {
    margin-top: 10px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
  }

  /* Estilos para las columnas de certificados */
  .certificate-row {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    flex-wrap: nowrap !important;
  }
  
  .certificate-col {
    padding: 0 5px !important;
    min-width: 0 !important;
    flex-shrink: 1 !important;
  }
  
  .certificate-field {
    text-align: left !important;
    overflow: hidden !important;
  }
  
  .certificate-label {
    color: #666 !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    margin-bottom: 2px !important;
    display: block !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .certificate-value {
    color: #333 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    word-wrap: break-word !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .certificate-actions {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 8px !important;
    min-width: 80px !important;
    flex-shrink: 0 !important;
  }
  
  .certificate-link {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.1) !important;
    transition: background 0.2s ease !important;
  }

  .certificate-link:hover {
    background: rgba(255, 255, 255, 0.2) !important;
  }

  /* Estilos para el popup de selección de documentos */
  .documento-item {
    padding: 0 !important;
  }

  .documento-content {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0 !important;
    width: 100% !important;
  }

  .documento-nombre {
    flex: 1 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #333 !important;
    margin-right: 15px !important;
    word-wrap: break-word !important;
  }

  .documento-acciones {
    display: flex !important;
    gap: 4px !important;
    flex-shrink: 0 !important;
  }

  .documento-acciones .button {
    min-width: 32px !important;
    height: 32px !important;
    padding: 0 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  /* Estilo para el diálogo de eliminar documento con mayor ancho */
  .dialog-eliminar-documento .dialog-inner {
    max-width: 90% !important;
    width: 600px !important;
    min-width: 400px !important;
  }
  
  .dialog-eliminar-documento .dialog-text {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    line-height: 1.4 !important;
  }

  .dialog-eliminar-documento .dialog-text strong {
    display: block !important;
    margin-top: 8px !important;
    padding: 8px 12px !important;
    background-color: #f5f5f5 !important;
    border-radius: 4px !important;
    border-left: 3px solid #ff3b30 !important;
    font-family: monospace !important;
    font-size: 13px !important;
    color: #333 !important;
  }

</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import EnvioMail from "../../components/envio-mail.vue";
import { emailConfigs } from "../../js/email-configs.js";
import ListadoMails from "./../../components/listado-mails.vue";
import ListadoTareas from "./../../components/listado-tareas.vue";
import Factura from "./../../js/db/Factura.js";
import Inspeccion from "./../../js/db/Inspeccion.js";
import Documento from "./../../js/db/Documento.js";
import Property from "./../../js/db/Property.js";
import Utils from "./../../js/Utils.js";
import RegistroEmail from "./../../js/db/RegistroEmail.js";
import TareaForm from "../tareas/tarea-form.vue";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    mandatoryFilter: {
      type: Object,
      default: () => null
    },
    searchOnInit: {
      type: Boolean,
      default: false
    },
    ignoreTableFilters: {
      type: Boolean,
      default: false
    },
    shownFields: {
      type: Array,
      default: () => []
    }
  },
  components: {
    rDynamicList,
    EnvioMail,
    TareaForm,
    ListadoMails,
    ListadoTareas
  },
  data() {
    return {
      Factura,
      Inspeccion,
      Documento,
      Property,
      Utils,
      RegistroEmail,
      enviarEmail: false,
      emailConfigs,
      verListadoMails: false,
      verListadoTareas: false,
      numeroFactura: null,
      codigoTarea: null,
      codigo: null,
      id: null,
      selectedItems: [],
      certificados: [],
      certificadosSeleccionados: [],
      certificadosParaEmail: [],
      filtroTexto: '',
      mostrarSeleccionCertificados: false,
      windowWidth: window.innerWidth,
      documentosDisponibles: [],
      itemFacturaActual: null,
      showDocumentosPopup: false,
      popupTareasOpened: false,
      dataTarea: {},
    };
  },
  computed: {
    computedShownFields() {
      const defaultFields = ['codigo', 'numero', 'tipo', 'lineasFactura', 'numDoc', 'docTotal', 'documentoFactura','saldoVencido', 'bcId'];
      return [...new Set([...defaultFields, ...this.shownFields])];
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
    isTablet() {
      return this.windowWidth > 768 && this.windowWidth <= 1024;
    },
    isDesktop() {
      return this.windowWidth > 1024;
    },
    
    // Computed property para filtrar certificados de forma reactiva
    certificadosFiltradosComputed() {
      const self = this;
      
      if (!self.certificados || self.certificados.length === 0) {
        return [];
      }
      
      if (!self.filtroTexto || self.filtroTexto === '') {
        return [...self.certificados];
      }
      
      const textoFiltro = self.filtroTexto.toLowerCase();
      
      return self.certificados.filter(certificado => {
        const codigoMatch = (certificado.codigoExpediente || '').toLowerCase().includes(textoFiltro);
        const estadoMatch = (certificado.estadoExpediente || '').toLowerCase().includes(textoFiltro);
        const numeroFacturaMatch = (certificado.numeroFactura ? String(certificado.numeroFactura).toLowerCase() : '').includes(textoFiltro);
        const clienteMatch = (certificado.cliente && certificado.cliente.razonSocial ? certificado.cliente.razonSocial.toLowerCase() : '').includes(textoFiltro);
        
        return codigoMatch || estadoMatch || numeroFacturaMatch || clienteMatch;
      });
    }
  },
  methods: {
    verEnBC: function (bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para esta factura.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir la factura en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=132';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    getResponsiveControlsWidth(ancho) {
      if (this.isMobile) return 0.8*ancho;
      if (this.isTablet) return 0.9*ancho;
      return 1*ancho;
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    filasSeleccionadas(item = null) {
      if (item) {
        return [{ id: item.id }];
      }
      
      return Object.values(this.$refs.facturasList?.selected || {})
        .map(selected => ({ id: selected.id }));
    },

    abrirEnvioEmail(items) {
      // TODO Guardar en alguna parte esta lista de items seleccionados, hasta que se cierre el popup de envio de emails.
      this.selectedItems = items.map(item => ({ id: item.id }));
      this.enviarEmail = true;
    },

    download(item) {
      var self = this;
      if (item.documentoFactura) {
        window.open(self.Documento.getDocumentoPublicUrl(item.documentoFactura), "_blank");
      } else {
        self.seleccionarDocumento(item);
      }
    },

    seleccionarDocumento(item) {
      var self = this;
      // Buscar documentos en la carpeta de facturas para que el usuario pueda seleccionar cual asignar
      Property.getList({filter: {nombre: 'factura.ruta'} }).then(function(res) {
        let ruta = res && res.list && res.list[0]? res.list[0].valor : null;
        if(ruta){
          // con la ruta de las facturas, le añadiremos el filtro de documentos /*_<numDoc>_*.pdf
          ruta = (ruta + '/*_' + item.numero + '_*.pdf').replace(/\/\//g, '/'); // Aseguramos que no haya dobles barras
          // Llamamos al método ls de Documento para listar los documentos en la ruta especificada
          Documento.ls(ruta)
            .then(res => {
              // si se han encontrado documentos, se los mostramos al usuario para que seleccione uno y al hacer click sobre el que quiere, se asignará.
              if (res && res.list && res.list.length > 0) {
                // Crear lista de documentos para el popup
                self.documentosDisponibles = res.list;
                self.itemFacturaActual = item;
                self.showDocumentosPopup = true;
              } else {
                self.$f7.dialog.alert(self.$t('facturas.no_documentos_encontrados'));
              }
            })
            .catch(err => {
              console.error(err);
              self.$f7.dialog.alert(self.$t('common.error') + ': ' + (err.message || err));
            });
        } else {
          self.$f7.dialog.alert(self.$t('facturas.ruta_no_configurada'));
        }
      }).catch(function(error) {
        if (error.message) {
          self.$f7.dialog.alert(error.message);
        } else {
          self.$f7.dialog.alert(error);
        }
      });
    },

    showMenuOptions(item) {
      var self = this;
      
      // Definir todas las opciones con sus condiciones
      const todasLasOpciones = [
        {
          text: `<i class="f7-icons">eye</i> ${self.$t('common.ver')}`,
          color: 'green',
          onClick: () => {
            self.$f7router.navigate(`/facturas/view/${item.id}/`);
          }
          // condition: undefined (siempre se muestra)
        },
        {
          text: `<i class="f7-icons">square_pencil</i> ${self.$t('common.editar')}`,
          onClick: () => {
            self.$f7router.navigate(`/facturas/edit/${item.id}/`);
          },
          condition: !!item.estado && item.docStatus === 'O'
        },
        {
          text: `<i class="f7-icons">doc_text</i> ${self.$t(item.bcId ? 'facturas.actualizar_documento_factura' : 'facturas.crear_documento_factura')}`,
          color: 'blue',
          onClick: () => {
            self.crearPdf([item]);
          }
        },
        {
          text: `<i class="f7-icons">doc</i> ${self.$t('common.descargar')}`,
          color: 'green',
          onClick: () => {
            self.download(item);
          },
          condition: !!item.documentoFactura
        },
        {
          text: `<i class="f7-icons">folder</i> ${self.$t('facturas.seleccionar_documento')}`,
          color: 'gray',
          onClick: () => {
            self.seleccionarDocumento(item);
          }
        },
        {
          text: `<i class="f7-icons">checkmark_alt</i> ${self.$t('facturas.crear_tarea')}`,
          color: 'blue',
          onClick: () => {
            self.crearTarea([item]);
          }
        },
        {
          text: `<i class="f7-icons">star</i> ${self.$t('facturas.crear_oportunidad')}`,
          onClick: () => {
            self.crearOportunidad(item);
          }
        },
        {
          text: `<i class="f7-icons">envelope</i> <b>${self.$t('facturas.enviar_email')}</b>`,
          onClick: () => {
            self.enviarEmailFactura(item);
          }
        },
        {
          text: `<i class="f7-icons">list_bullet</i> ${self.$t('facturas.mostrar_tareas')}`,
          color: 'green',
          onClick: () => {
            self.mostrarTareas(item);
          }
        },
        {
          text: `<i class="f7-icons">star_circle</i> ${self.$t('facturas.mostrar_oportunidades')}`,
          color: 'green',
          onClick: () => {
            self.mostrarOportunidades(item);
          }
        },
        {
          text: `<i class="f7-icons">envelope_open</i> ${self.$t('facturas.mostrar_emails')}`,
          color: 'green',
          onClick: () => {
            self.mostrarEmails(item);
          }
        }
      ];

      // Filtrar opciones basándose en la propiedad condition
      const opcionesFiltradas = todasLasOpciones.filter(opcion => {
        return opcion.condition === undefined || opcion.condition === true;
      });

      const buttons = [
        // Grupo principal de opciones filtradas
        opcionesFiltradas,
        // Grupo de cancelar
        [
          {
            text: self.$t('common.cancelar'),
            color: 'red'
          }
        ]
      ];

      self.$f7.actions.create({
        buttons: buttons,
        cssClass: 'actions-centered'
      }).open();
    },

    crearPdf(items) {
      var self = this;
      const facturas = items.map(item => (item.id));
      let itemsValidos = items.filter(f => f); 
      if(itemsValidos.length === 1 && itemsValidos[0] && itemsValidos[0].bcId){
        self.ejecutarCrearPdf(facturas, false);
        return;
      }
      // Preguntar al usuario si quiere agrupar comisiones y subcontrataciones
      self.$f7.dialog.create({
        title: self.$t('facturas.opciones_pdf'),
        text: '¿Desea que los importes de comisiones y subcontrataciones aparezcan <b>agrupados</b> o <b>desagrupados</b>?',
        buttons: [
          {
            text: 'Desagrupados',
            onClick: () => {
              self.ejecutarCrearPdf(facturas, false);
            }
          },
          {
            text: 'Agrupados',
            onClick: () => {
              self.ejecutarCrearPdf(facturas, true);
            }
          },
          {
            text: 'Cancelar',
            color: 'gray'
          }
        ],
        cssClass: 'dialog-crear-pdf'
      }).open();
    },

    ejecutarCrearPdf(facturas, agruparCyS) {
      var self = this;
      // Mostrar un popup con el formulario de creación de tarea al que le pasamos las facturas seleccionadas.
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Factura.crearPDF({ tipo: 'SAP', ids: facturas, agruparCyS: agruparCyS })
        .then(response => {
          self.$f7.dialog.alert(self.$t('facturas.pdfs_generados_correctamente'));
          espera.cerrar();
          // Recargar la lista de facturas para reflejar los cambios
          self.$refs.facturasList.reload();
        })
        .catch(error => {
          console.error('Error al crear PDFs masivo:', error);
          espera.cerrar();
          self.$f7.dialog.alert(self.$t('common.error') + ': ' + (error.message || error));
        });
    },
    asignarPdf(items) {
      var self = this;
      // Mostrar un popup con el formulario de creación de tarea al que le pasamos las facturas seleccionadas.
      const facturas = items.map(item => (item.id));
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Factura.asociarDocumentoFactura(facturas)
        .then(response => {
          self.$f7.dialog.alert(self.$t('facturas.pdf_asignado_correctamente'));
          espera.cerrar();
          // Recargar la lista de facturas para reflejar los cambios
          self.$refs.facturasList.reload();
        })
        .catch(error => {
          console.error('Error al asignar PDF masivo:', error);
          espera.cerrar();
          self.$f7.dialog.alert(self.$t('common.error') + ': ' + (error.message || error));
        });
    },
    crearTarea(items) {
      var self = this;
      // Mostrar un popup con el formulario de creación de tarea al que le pasamos las facturas seleccionadas.
      const facturas = items.map(item => ({
        id: item.id,
        codigo: item.codigo,
        numero: item.numero || item.numDoc,
        tipo: item.tipo
      }));
      self.dataTarea = {
        facturas: facturas,
        estado: 'PENDIENTE',
        importe: Math.round(items.reduce((sum, item) => sum + (item.saldoVencido || 0), 0) * 100) / 100,
        username: Utils.getUser().username,
      };
      // const url = `#!/tarea/new/?jsonData=${JSON.stringify(dataTarea)}`;
      // window.open(url, '_blank');
      self.popupTareasOpened = true;
    },

    crearOportunidad(item) {
      var self = this;
      // Mock method - crear oportunidad relacionada con la factura
      console.log('Crear oportunidad para factura:', item);
      self.$f7.dialog.alert(`${self.$t('facturas.creando_oportunidad')} ${item.numero || item.id}`, self.$t('facturas.crear_oportunidad'));
    },

    enviarEmailFactura(item) {
      var self = this;
      console.log('Enviar email para factura:', item);
      self.abrirEnvioEmail([item]);
    },

    mostrarTareas(item) {
      var self = this;
      console.log('Mostrar tareas para factura:', item);
      self.codigo = item.codigo;
      self.verListadoTareas = true;
    },

    mostrarOportunidades(item) {
      var self = this;
      // Mock method - mostrar oportunidades relacionadas con la factura
      console.log('Mostrar oportunidades para factura:', item);
      self.$f7.dialog.alert(`${self.$t('facturas.mostrando_oportunidades')} ${item.numero || item.id}`, self.$t('facturas.mostrar_oportunidades'));
    },

    mostrarEmails(item) {
      var self = this;
      console.log('Mostrar emails para factura:', item);
      self.id = item.id;
      self.verListadoMails = true;
    },

    seleccionarCertificados() {
      const self = this;
      
      // Obtener los IDs de las facturas seleccionadas
      const facturasSeleccionadas = self.selectedItems;
      const idsFacturas = facturasSeleccionadas.map(factura => factura.id);
      
      if (idsFacturas.length === 0) {
        self.$f7.dialog.alert('No hay facturas seleccionadas');
        return;
      }
      
      // Mostrar loading
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      
      // Llamar al método para obtener certificados
      self.$f7.toast.create({
            text: `Se buscarán todos los certificados de las facturas seleccionadas, esto puede llevar su tiempo.`,
            position: 'center',
            closeTimeout: 3000
          }).open();
      Factura.certificadosPorFacturas(idsFacturas)
        .then(response => {
          console.log('📋 Certificados recibidos del backend:', response);
          
          // Añadir campo selected a cada certificado
          const certificadosConSeleccion = response.map(cert => ({
            ...cert,
            selected: true
          }));
          
          // Guardar los certificados en el campo data
          self.certificados = certificadosConSeleccion;
          self.certificadosSeleccionados = [];
          self.filtroTexto = '';
          
          console.log('✅ Certificados procesados con campo selected:', self.certificados);
          
          // Mostrar popup de selección de certificados
          self.mostrarSeleccionCertificados = true;
          
          // Usar nextTick para asegurar que el popup se renderice antes de actualizar la selección
          self.$nextTick(() => {
            self.actualizarCertificadosSeleccionados();
            console.log('✅ Certificados seleccionados inicializados después del render:', self.certificadosSeleccionados.length);
            
            // Forzar actualización del componente para asegurar que la UI se actualice
            self.$forceUpdate();
          });
        })
        .catch(error => {
          console.error('Error al seleccionar certificados:', error);
          self.$f7.dialog.alert(`Error al obtener certificados: ${error.message}`);
        })
        .finally(() => {
          // Ocultar loading
          espera.cerrar();
        });
    },
    
    // Métodos para la selección de certificados
    filtrarCertificados(e) {
      const self = this;
      const textoFiltro = e.target.value;
      console.log('🔍 Filtrando certificados con texto:', textoFiltro);
      
      // Solo actualizar el valor del filtro, el computed se encarga del resto
      self.filtroTexto = textoFiltro;
      
      console.log(`📊 Certificados que coinciden: ${self.certificadosFiltradosComputed.length} de ${self.certificados.length}`);
    },
    
    limpiarFiltro() {
      const self = this;
      console.log('🧹 Limpiando filtro de certificados');
      
      // Solo resetear el filtro, el computed se encarga del resto
      self.filtroTexto = '';
      
      console.log('✅ Filtro limpiado. Mostrando todos los certificados:', self.certificadosFiltradosComputed.length);
    },
    
    esCertificadoSeleccionado(certificado) {
      const isSelected = certificado && certificado.selected === true;
      console.log(`🔍 Verificando selección para certificado ${certificado?.id}:`, isSelected);
      return isSelected;
    },
    
    toggleCertificadoSeleccion(certificado) {
      const self = this;
      console.log(`🎯 Click en certificado ${certificado.id}, estado actual:`, certificado.selected);
      
      // Cambiar el estado selected del certificado
      self.$set(certificado, 'selected', !certificado.selected);
      
      console.log(`✅ Nuevo estado para certificado ${certificado.id}:`, certificado.selected);
      
      // Actualizar array de seleccionados para estadísticas
      self.actualizarCertificadosSeleccionados();
      
      // Forzar actualización de la UI
      self.$forceUpdate();
    },
    
    actualizarCertificadosSeleccionados() {
      const self = this;
      // Filtrar todos los certificados que están marcados como selected
      const seleccionados = self.certificados.filter(cert => cert.selected === true);
      
      // Usar $set para asegurar reactividad
      self.$set(self, 'certificadosSeleccionados', seleccionados);
      
      console.log(`📊 Certificados seleccionados actualizados: ${self.certificadosSeleccionados.length}`, self.certificadosSeleccionados.map(c => c.id));
    },
    
    seleccionarTodosVisibles() {
      const self = this;
      console.log('🎯 Seleccionando todos los certificados visibles...');
      console.log('📋 Certificados visibles:', self.certificadosFiltradosComputed.map(c => c.id));
      
      self.certificadosFiltradosComputed.forEach(certificado => {
        if (!certificado.selected) {
          console.log(`✅ Seleccionando certificado ${certificado.id}`);
          self.$set(certificado, 'selected', true);
        }
      });
      
      self.actualizarCertificadosSeleccionados();
      self.$forceUpdate();
    },
    
    deseleccionarTodosVisibles() {
      const self = this;
      console.log('🎯 Deseleccionando todos los certificados visibles...');
      console.log('📋 Certificados visibles:', self.certificadosFiltradosComputed.map(c => c.id));
      
      self.certificadosFiltradosComputed.forEach(certificado => {
        if (certificado.selected) {
          console.log(`❌ Deseleccionando certificado ${certificado.id}`);
          self.$set(certificado, 'selected', false);
        }
      });
      
      self.actualizarCertificadosSeleccionados();
      self.$forceUpdate();
    },
    
    confirmarSeleccionCertificados() {
      const self = this;
      
      console.log('🔍 Confirmando selección...');
      console.log('📊 Certificados seleccionados:', self.certificadosSeleccionados.length);
      console.log('📋 Lista de certificados seleccionados:', self.certificadosSeleccionados);
      
      if (self.certificadosSeleccionados.length === 0) {
        console.log('❌ No hay certificados seleccionados');
        self.$f7.dialog.alert('Debe seleccionar al menos un certificado');
        return;
      }
      
      // Guardar los certificados seleccionados para uso posterior
      self.certificadosParaEmail = self.certificadosSeleccionados.map(cert => ({...cert}));
      
      // Añadir "Certificado" al campo documentosAAdjuntar del formulario de email si existe
      self.agregarCertificadoAEmail();
      
      // Cerrar el popup
      self.mostrarSeleccionCertificados = false;

      // añadiremos a cada elemento de self.selectedItems los certificados seleccionados que tengan el mismo idFactura
      self.selectedItems.forEach(item => {
        item.certificados = self.certificadosParaEmail.filter(cert => cert.idFactura === item.id);
      });

      // Mostrar toast de confirmación
      self.$f7.toast.create({
        text: `Se seleccionaron ${self.certificadosSeleccionados.length} certificados y se añadió "Certificado" a los documentos a adjuntar`,
        position: 'center',
        closeTimeout: 3000
      }).open();
      
      console.log('✅ Selección confirmada:', self.certificadosSeleccionados);
    },
    
    agregarCertificadoAEmail() {
      const self = this;
      // Intentar acceder al componente de envío de email
      const envioMailComponent = self.$refs.enviarEmail;
      
      if (envioMailComponent && envioMailComponent.$refs.rformEnviarEmail) {
        const rform = envioMailComponent.$refs.rformEnviarEmail;
        
        if (rform.formData) {
          console.log('📧 Añadiendo "Certificado" al formulario de email');
          
          // Inicializar documentosAAdjuntar si no existe
          if (!rform.formData.documentosAAdjuntar) {
            self.$set(rform.formData, 'documentosAAdjuntar', []);
          }
          
          // Verificar si "Certificado" ya está en la lista
          const yaExiste = rform.formData.documentosAAdjuntar.includes('Certificado');
          
          if (!yaExiste) {
            rform.formData.documentosAAdjuntar.push('Certificado');
            console.log('✅ "Certificado" añadido a documentosAAdjuntar');
          } else {
            console.log('ℹ️ "Certificado" ya estaba en documentosAAdjuntar');
          }
        }
      } else {
        console.log('⚠️ No se pudo acceder al componente de envío de email o su formulario');
      }
    },

    abrirInspeccion(idExpediente) {
      const url = `?#!/inspecciones/view/${idExpediente}/`;
      window.open(url, '_blank');
    },
    descargarCertificado(certificado, beta = false){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      let inspeccion = {
        id: certificado.idExpediente,
        codigo: certificado.codigoExpediente,
        cliente: certificado.cliente,
      };
      Inspeccion.descargarCertificado(inspeccion, beta)
        .catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          if(e.message) {
            app.dialog.alert(e.message);
          } else {
            var e = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response)));
            if (e &&  e.error && e.error.code == 'ERROR_AUDITORIA') {
              var message = e.error.message + " :<ul>";
              e.error.errors.forEach( err => {message+= "<li>"+err+"</li>";})
              message+="</ul>";
              app.dialog.alert(message + " <br> ");
            } else {
            var msg = e.error.message;
            app.dialog.alert(msg);
            }
          } 
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    visualizarCertificado(certificado, beta = false){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      let inspeccion = {
        id: certificado.idExpediente,
        codigo: certificado.codigoExpediente,
        cliente: certificado.cliente,
      };
      // Inspeccion.descargarCertificado(inspeccion, beta)
      Inspeccion.visualizarCertificado(inspeccion, beta)
        .catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          if(e.message) {
            app.dialog.alert(e.message);
          } else {
            var e = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response)));
            if (e &&  e.error && e.error.code == 'ERROR_AUDITORIA') {
              var message = e.error.message + " :<ul>";
              e.error.errors.forEach( err => {message+= "<li>"+err+"</li>";})
              message+="</ul>";
              app.dialog.alert(message + " <br> ");
            } else {
            var msg = e.error.message;
            app.dialog.alert(msg);
            }
          } 
        }).finally(function(e) {
          espera.cerrar();
        });
    },

    onEmailEnviado() {
      // Cerrar el popup de envío de email
      this.enviarEmail = false;
      
      // Refrescar la lista de facturas
      if (this.$refs.facturasList) {
        this.$refs.facturasList.reload();
      }
    },

    // Métodos para la gestión de documentos
    descargarDocumento(documento) {
      const url = this.Documento.getDocumentoPublicUrl(documento);
      window.open(url, "_blank");
    },

    asignarDocumento(documento) {
      var self = this;
      if (self.itemFacturaActual) {
        self.$set(self.itemFacturaActual, 'documentoFactura', documento);
        // Asignar el documento seleccionado al item
        Factura.asignaDocumentoFactura({itemId: self.itemFacturaActual.id, data: self.itemFacturaActual});
        self.$f7.toast.create({
          text: `Documento ${documento.nombre}.${documento.extension} asignado correctamente`,
          position: 'center',
          closeTimeout: 2000
        }).open();
        // Cerrar el popup
        self.showDocumentosPopup = false;
      }
    },

    eliminarDocumento(documento) {
      var self = this;
      self.$f7.dialog.create({
        title: 'Confirmar eliminación',
        text: `¿Está seguro de que desea eliminar el documento?<br><br><strong>${documento.nombre}.${documento.extension}</strong>`,
        buttons: [
          {
            text: 'Cancelar',
            color: 'gray'
          },
          {
            text: 'Eliminar',
            color: 'red',
            onClick: function() {
              Factura.eliminaDocumentoFactura({id: self.itemFacturaActual.id, documentoFactura: documento})
              .then(() => {
                self.$f7.toast.create({
                  text: `Documento ${documento.nombre}.${documento.extension} eliminado correctamente`,
                  position: 'center',
                  closeTimeout: 2000
                }).open();
                
                // Eliminar el documento de la lista sin hacer reload
                const indiceDocumento = self.documentosDisponibles.findIndex(doc => 
                  doc.nombre === documento.nombre && doc.extension === documento.extension
                );
                if (indiceDocumento !== -1) {
                  self.documentosDisponibles.splice(indiceDocumento, 1);
                }
                
                // Si no quedan más documentos, cerrar el modal
                if (self.documentosDisponibles.length === 0) {
                  self.showDocumentosPopup = false;
                  self.$f7.toast.create({
                    text: 'No hay más documentos disponibles',
                    position: 'center',
                    closeTimeout: 2000
                  }).open();
                }
                
                // Recargar la lista de facturas para reflejar los cambios
                self.$refs.facturasList.reload();
              })
              .catch(() => {
                self.$f7.toast.create({
                  text: `La eliminación de ${documento.nombre}.${documento.extension} dio error`,
                  position: 'center',
                  closeTimeout: 3000
                }).open();
              });
            }
          }
        ],
        cssClass: 'dialog-eliminar-documento'
      }).open();
    }
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    
    // Listener para cambios de tamaño de ventana
    window.addEventListener('resize', this.handleResize);
    
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
    // Vamos a personalizar la emailConfigs para la factura, añadiremos a documentosOpciones un campo extra action en la configuración de expedientes
    emailConfigs.factura.documentosOpciones.forEach(opcion => {
      if(opcion.name === 'Certificado'){
        opcion.action = self.seleccionarCertificados;
      }
    });
  },
  
  beforeDestroy() {
    // Limpiar el listener
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>
